// Dominios de la API. Se fijan al compilar (VUE_APP_API_URL); por defecto, los de producción actual.
const api = (process.env.VUE_APP_API_URL || 'https://api4drive.unocomaseis.com').replace(/\/+$/, '');

export const dominio = api + '/api';
export const server = api + '/';
